import { Button } from '../../components/button/button';
import { Modal } from '../../components/modal/modal';
import { useLang } from '../../hooks/use-lang';
import { useQueryParams } from '../../hooks/use-query-params';
import { useToggle } from '../../hooks/use-toggle';
import s from './restore-modal.module.css';

interface Props {
  onSubmit: (id: string) => Promise<void>;
}

export const RestoreModal = (props: Props) => {
  const { onSubmit } = props;
  const { t } = useLang();

  const { addQueryParams, getQueryParams } = useQueryParams();
  const params = getQueryParams();

  const id = params.restoreId;
  const name = params.restoreName;

  const [isLoading, , setIsLoading] = useToggle();

  const handleClose = () => addQueryParams({ restoreId: undefined, restoreName: undefined });

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      await onSubmit(id);
      handleClose();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const isOpen = !!id && !!name;
  if (!isOpen) return null;

  return (
    <Modal className={s.feature} title={t('Восстановление')} onClose={handleClose}>
      {t('Вы уверены, что хотите восстановить {{name}}?', {
        name,
      })}
      <div className={s.controls}>
        <Button onClick={handleClose} disabled={isLoading} variant="secondary">
          {t('Отменить')}
        </Button>
        <Button onClick={handleSubmit} disabled={isLoading}>
          {t('Восстановить')}
        </Button>
      </div>
    </Modal>
  );
};
